module.exports = __webpack_public_path__ + "static/media/thandanani_majola.42479bc0.jpeg";